import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Divar.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import AppBody from "./AppBody";
import DivarItem from "../Modules/DivarItem";
import Message from "../Modules/Message";

class Messages extends React.Component{
    list =[];
    hasMoreItemsToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            page: 1,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            readAll:0,
            messages: [],
        };
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }
    componentWillMount() {

    }
    componentDidMount = () => {
        this.content = document.getElementsByClassName("content")[0];
        this.getMessages();
        this.content.addEventListener("scroll",this.handleScroll,false);
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );
        return (
            <AppBody loading={this.state.loading} name={"پیام ها"} type={" alice"}>
                {this.renderItems()}
            </AppBody>
        );
    }
    renderItems(){
        return this.state.messages.map((item)=>{
            return(
                <div className={"divarItem"}>
                    <div className={"divarImgDiv message"}>
                        <img className={"divarImg"} src={`${process.env.PUBLIC_URL}/assets/images/`+((item.status === 1)?"message_new.png":"message_read.png")}/>
                    </div>
                    <div className={"divarInfo message"}>
                        <div className={"divarTitle"}>{item.title}</div>
                        <div  dangerouslySetInnerHTML={{__html: item.body}}  className={"divarText"}/>
                        <div className={"divarDate"}>{item.created_at}</div>
                    </div>
                    </div>
            );
        })
    }


    handleCategoryClick(id){
        if(id != null)
            this.setState({cat_id:id,page:1},() => {
                this.getDivarItems();
            });
        else
            console.log(id);
    }
    getMessages(){
        this.setState({loading:true});
        if(this.state.page === 1)
            this.setState({ messages: []});
        axios.get(urls.baseUrl+urls.getMessages+"?"
            +"token="+ls.get("token")
            +"&read_all="+this.state.readAll
            +"&page="+this.state.page
        )
            .then(res => {
                if(res.data.code == 200){
                    if(res.data.data.length === 0)
                        this.hasMoreItemsToLoad = false;
                    else
                        this.hasMoreItemsToLoad = true;

                    let messages = [];
                    res.data.data.forEach((item)=>{
                        let it = new Message(item);
                        messages.push(it);
                    });
                    this.setState({
                        messages:[...this.state.messages, ...messages],
                        loading:false},()=>{
                        this.content.addEventListener("scroll",this.handleScroll,false);
                    });

                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false},()=>{
                    this.content.addEventListener("scroll",this.handleScroll,false);
                });
            });


    }
    handleScroll = (event) => {
        if(!this.hasMoreItemsToLoad){
            event.target.removeEventListener("scroll", this.handleScroll);
            return;
        }

        if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 2 && !this.isLoadingMore){
            event.target.removeEventListener("scroll", this.handleScroll);

            this.setState({page:this.state.page+1},() => {
                this.getMessages();
            })
        }
    };
}



export default Messages;
